// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import './style/global.css'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import globalData from './common/globalData'
import globalFunc from './common/globalFunc'
import * as InterfaceApi from './common/api.js'

Vue.prototype.GLOBAL = globalData
Vue.prototype.$api = InterfaceApi
Vue.prototype.msgSuccess = function (msg, size = 'small') {
  this.$message({ showClose: true, message: msg, type: 'success', customClass: `message-${size}` })
}

Vue.prototype.msgError = function (msg, size = 'small') {
  this.$message({ showClose: true, message: msg, type: 'error', customClass: `message-${size}` })
}

Vue.prototype.msgInfo = function (msg) {
  this.$message.info(msg)
}

Vue.config.productionTip = false

Vue.use(ElementUI)
Vue.use(globalFunc)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js